export enum Roles {
  SystemAdministrator = 1,
  OrganisationalAdministrator = 2,
  ContentAdministrator = 3,
  Tutor = 4,
  Learner = 5,
  GlobalAdministrator = 6,
  Guest = 99,
}

export const ADMIN_ROLES = [
  Roles.SystemAdministrator,
  Roles.OrganisationalAdministrator,
  Roles.GlobalAdministrator,
];

export const ORG_PERMISSION_ROLES = [
  Roles.OrganisationalAdministrator,
  Roles.Tutor,
];
export const SYS_GLOBAL_ROLES = [Roles.SystemAdministrator, Roles.GlobalAdministrator];